import { jsonMember, jsonObject } from 'typedjson';
import { OrderStatus } from '../../../shared/enums';
import { PublicCheckoutOrderPaymentMethodResponse } from './public-checkout-order-payment-method.response';
import { Nillable } from '@web/utils';
import { OrderNumber } from '../../../shared/types';

@jsonObject
export class PublicCheckoutOrderDetailsResponse {
  @jsonMember(String)
  public readonly number!: OrderNumber;

  @jsonMember(String)
  public readonly status!: OrderStatus;

  @jsonMember(Number)
  public readonly totalPrice!: number;

  @jsonMember(PublicCheckoutOrderPaymentMethodResponse)
  public readonly paymentMethod!: PublicCheckoutOrderPaymentMethodResponse;

  @jsonMember(String)
  public readonly redirectUrl?: Nillable<string>;
}
